import React, {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Modal} from 'components/ui-kit/Modal';

import {CancelButton, CheckResult, CodeImage, ContentWrapper, Text} from './styled';

export function CheckCodeModal() {
    const {t} = useTranslation();
    const [show, setShow] = useState(false);
    const isLoading = false;
    const isChecking = false;

    const title = isLoading
        ? t('pages.dashboard.modal.loading')
        : t('pages.dashboard.modal.checking');

    return (
        <Modal title={title} show={show} onClose={() => setShow(false)}>
            <ContentWrapper>
                {isLoading && (
                    <>
                        <p>{t('pages.dashboard.modal.fileUploading')}</p>
                        <p>{t('pages.dashboard.modal.loading')}...</p>
                        <CancelButton>{t('pages.dashboard.modal.cancel')}</CancelButton>
                    </>
                )}
                {isChecking && (
                    <>
                        <Text>
                            {t('pages.dashboard.modal.fileAnalyse')}
                            <br /> {t('pages.dashboard.modal.fileAnalyseDesc')}
                        </Text>
                        <CodeImage src="https://via.placeholder.com/600x400" alt="marking code" />
                        <CancelButton>{t('pages.dashboard.modal.cancel')}</CancelButton>
                    </>
                )}
                {!isLoading && !isChecking && (
                    <>
                        <CheckResult original={true}>
                            {t('pages.dashboard.modal.markingOriginal')}
                        </CheckResult>
                        <CodeImage src="https://via.placeholder.com/600x400" alt="marking code" />
                    </>
                )}
            </ContentWrapper>
        </Modal>
    );
}
